<div class="flex gap-2.5 items-center">
  <div
    [ngClass]="{
      disabled: disabledRemove,
    }"
    [attr.disabled]="disabledRemove ? true : null"
    (click)="deleteItem()"
    class="remove-btn icon-minus-box"
  ></div>
  <div [appTooltip]="disableAddTooltip()">
    <div
      [ngClass]="{
        disabled: disabledAdd,
      }"
      [attr.disabled]="disabledAdd ? true : null"
      (click)="insertItem()"
      class="add-btn icon-plus-box"
    ></div>
  </div>
</div>
